import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/template/Layout'

import LoginTest from '@/components/inicio/LoginTest'
import UnknowPassword from '@/components/inicio/UnknowPassword'
import ChangePassword from '@/components/inicio/ChangePassword'
import IntroDca from '@/components/inicio/IntroDCA'

import Dca from '@/components/primeraEtapa/Dca'
import Dge from '@/components/primeraEtapa/Dge'

import TemplateDge from '@/components/template/TemplateDge'

import IndicadorEvidencia from '@/components/dca/indicadores/IndicadorEvidencia'
import Indicador2014 from '@/components/dca/indicadores/Indicador2014'


import DcaCarrera from '@/components/dca/archivosDca/DcaCarrera'
import D1e from '@/components/dca/evaluacion/D1e'
import EvaluacionDimension from '@/components/dca/evaluacion/EvaluacionDimension'
import D1Post from '@/components/dca/evaluacion/D1Post'

import Plan2 from '@/components/dca/mejoramiento/Plan2'
import DefinicionIndicadores from '@/components/dca/mejoramiento/DefinicionIndicadores'

import Hitos from '@/components/dca/seguimiento/Hitos'

import ListaAdmin from '@/components/dca/archivosDca/ListaAdmin'
import Documentos from '@/components/dca/documentosPost/Documentos'
import DocumentosEtapa7 from '@/components/dca/documentosPost/DocumentosEtapa7'
import DocumentosEtapa5 from '@/components/dca/documentosPost/DocumentosEtapa5'
import Documentos45 from '@/components/dca/documentosPost/Documentos45'
import DocumentosActa from '@/components/dca/documentosPost/DocumentosActa'
import DocumentosIndicadores from '@/components/dca/documentosPost/DocumentosIndicadores'
import EvidenciaIndicadores from '@/components/dca/documentosPost/EvidenciaIndicadores'
import DocumentosAcciones from '@/components/dca/documentosPost/DocumentosAcciones'

import AnexosO from '@/components/dca/documentosPost/AnexosO'
import AnexosC from '@/components/dca/documentosPost/AnexosC'
import DocArea from '@/components/dca/documentosPost/DocumentosArea'

import Comentario from '@/components/dca/documentosPost/Comentario'



import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: '/loginTest',
      children: [

        {
          path: '/dca',
          name: 'dca',
          component: Dca
        },
        {
          path: '/dge',
          name: 'dge',
          component: Dge
        },
        {
          path: '/introDca',
          name: 'intro1',
          component: IntroDca
        },


        {
          path: '/ccm',
          name: 'ccm',
          component: ListaAdmin
        },
        {
          path: '/template',
          name: 'template',
          component: TemplateDge,
          redirect: 'template/video',

        },
        {
          path: 'evaluacion/d1post',
          name: 'd1post',
          component: D1Post,
        },

        {
          path: 'evaluacion/dimension/:id',
          name: 'dimension',
          component: EvaluacionDimension,
        },
        {
          path: 'evaluacion/criterio/:id',
          name: 'criterio',
          component: D1e,
        },
        {
          path: 'planes/:id',
          name: 'd1P',
          component: Plan2,
        },
        {
          path: '/indicadores/:id',
          name: 'indicadores',
          component: DefinicionIndicadores,
        },
        {
          path: 'hitos',
          name: 'hitos',
          component: Hitos,
        },
        {
          path: 'archivosDca',
          name: 'archivosDca',
          component: DcaCarrera,
        },

        {
          path: 'hello',
          name: 'hello',
          component: HelloWorld,
        },

        {
          path: '/documentos/:id',
          name: 'documentos',
          component: Documentos,
          redirect: { name: 'estadoE1' },
          children: [
            {
              path: 'estadoE1',
              name: 'estadoE1',
              component: Comentario
            },
            {
              path: 'anexosComplementarios',
              name: 'anexosC',
              component: AnexosC
            },
          ]
        },

        {
          path: '/documentosarea/:id',
          name: 'documentosArea',
          component: DocArea,          
        },

        {
          path: '/documentosActa',
          name: 'documentosActa',
          component: DocumentosActa,
          redirect: { name: 'acta' },
          children: [
            {
              path: 'acta',
              name: 'acta',
              component: AnexosO
            },
            {
              path: 'estadoActa',
              name: 'estadoActa',
              component: Comentario
            }
          ]
        },

        {
          path: '/documentosIndicadores/:id',
          name: 'indicadoresDoc',
          component: DocumentosIndicadores,
        },

        {
          path: '/documentosAcciones/:id',
          name: 'documentosAcciones',
          component: DocumentosAcciones,
        },

        {
          path: '/evidenciaEvaluacionCriterio/:id',
          name: 'evidenciaIndicadoresDoc',
          component: EvidenciaIndicadores,
        },

        {
          path: '/indicadoresEvidencia/:id',
          name: 'indicadoresEvidencia',
          component: IndicadorEvidencia,
        },
        {
          path: '/avance2014/',
          name: 'avance2014',
          component: Indicador2014,
        },

        {
          path: '/documentosFinales',
          name: 'documentosFinales',
          component: DocumentosEtapa7,
          redirect: { name: 'anexosO' },
          children: [
            {
              path: 'anexosObligatorios',
              name: 'anexosO',
              component: AnexosO
            },
            {
              path: 'anexosComplementarios',
              name: 'anexosC',
              component: AnexosC
            },
            {
              path: 'estadoE7',
              name: 'estadoE7',
              component: Comentario
            }
          ]
        },

        {
          path: '/documentosEtapa5',
          name: 'documentosEtapa5',
          component: DocumentosEtapa5,
          redirect: { name: 'anexosOEtapa5' },
          children: [
            {
              path: 'anexosObligatorios5',
              name: 'anexosOEtapa5',
              component: AnexosO
            },
            {
              path: 'docsAutoevaluacion5',
              name: 'anexosCEtapa5',
              component: AnexosO
            },
            {
              path: 'estadoE5',
              name: 'estadoE5',
              component: Comentario
            }
          ]
        },

        {
          path: '/documentos45',
          name: 'documentos45',
          component: Documentos45,
          redirect: { name: 'anexosO45' },
          children: [
            {
              path: 'anexosObligatorios45',
              name: 'anexosO45',
              component: AnexosO
            },
            {
              path: 'anexosComplementarios4',
              name: 'anexosC4',
              component: AnexosC
            },
            {
              path: 'estadoE4',
              name: 'estadoE4',
              component: Comentario
            }
          ]
        }

      ]
    },

    {
      path: '/login/changePass',
      name: 'changePass',
      component: ChangePassword
    },

    {
      path: '/loginTest',
      name: 'loginTest',
      component: LoginTest
    }
    ,

    {
      path: '/unknowPassword',
      name: 'unknowPassword',
      component: UnknowPassword
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js